import React from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { isEmbedded } from 'utils/stringUtils';
import GuideMeButton from '../components/GuideMeButton';
import Intro from '../components/Intro';
import FeaturedResources from '../components/VariantB/FeaturedResources';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '82px 0 82px 0',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
    },
    [theme.breakpoints.down('sm')]: {
      padding: props => (props.isEmbed ? '82px 0 82px 0' : 0),
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0 !important',
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },
    width: '100%',
    padding: '24px 5%',
    '& > div': {
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
      },
    },
    [theme.breakpoints.down('900')]: {
      padding: '24px 2%',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '24px 5% 0px 5%',
    },
  },
  leftContent: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: 20,
    },
  },
  btnWrapper: {
    '& > div': {
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
  },
}));

function VariantB() {
  const clientDetails = useSelector(makeSelectClientDetails());
  const isEmbed = isEmbedded();
  const useAppEmbedStyle =
    isEmbed || _get(clientDetails, 'metadata.useAppEmbedStyle', false);
  const classes = useStyles({ isEmbed: useAppEmbedStyle });
  const showGuideMeButton = _get(
    clientDetails,
    'metadata.showGuideMeButton',
    false,
  );

  return (
    <div className={classes.root} data-test-id="hero-variant-b">
      <Grid
        container
        className={classes.container}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={12} md={4} className={classes.leftContent}>
          <Grid container direction="column">
            <Intro fontSize={35} />
            <div className={classes.btnWrapper}>
              <GuideMeButton showGuideMeButton={showGuideMeButton} />
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={7}>
          <FeaturedResources />
        </Grid>
      </Grid>
    </div>
  );
}

VariantB.propTypes = {};

export default VariantB;
